import React from 'react';

const MapLoadingState = ({ isLoading }) => {
    if (!isLoading) return null;
    
    return (
        <div className="text-center my-4">
            Geocoding addresses...
        </div>
    );
};

export default MapLoadingState;
